<template>
  <div class="body_show" v-if="body_show">
    <div class="imgs">
      <img src="https://misc.xjy.cn/accelerator/ceping87/img1.png">
      <img src="https://misc.xjy.cn/accelerator/ceping87/img2.png">
      <img src="https://misc.xjy.cn/accelerator/ceping87/img3.png">
      <img src="https://misc.xjy.cn/accelerator/ceping87/img4.png">
      <img src="https://misc.xjy.cn/accelerator/ceping87/img5.png">
      <img src="https://misc.xjy.cn/accelerator/ceping87/img6.png">
      <img src="https://misc.xjy.cn/accelerator/ceping87/img7.png">
      <img src="https://misc.xjy.cn/accelerator/ceping87/img8.png">
      <img src="https://misc.xjy.cn/accelerator/ceping87/img9.png">
    </div>
    <!-- <div class="men_detail">
      <img src="@a/cp55_top.png" alt="" />
      <img class="logo" src="@a/ceping87/logo.png">
    </div> -->
    <!-- <div class="men_main">
      <h2 class="clearfix"><span class="pull-left"></span><span class="pull-right"></span></h2>
      <h3>测评简介<span></span></h3>
      <p>约翰·霍兰德（John Holland）认为人的人格类型、兴趣与职业密切相关，兴趣是人们活动的巨大动力，从事跟自己兴趣一致的职业，能够使人们工作起来更加积极和愉快。</p>
      <p>但是很多人却并不知道自己真正的兴趣是什么，于是在找工作的时候，迷茫、无措；工作以后，没有动力、得过且过。</p>
      <p class="last_child">测评研发团队依据霍兰德理论，对霍兰德职业兴趣测评进行了改编和本土化，更适合中国国情，报告内容也更加详细和实用，帮助大家寻找到自己的兴趣所在，不再迷茫，找准方向，绽放出生命的光彩。</p>
      <h3>您会获得什么？<span></span></h3>
      <ul>
        <li class="clearfix">
          <span class="pull-left"></span>
          <div class="pull-right lr">
            获取你的职业兴趣倾向类型是什么
          </div>
        </li>
        <li class="clearfix">
          <span class="pull-left"></span>
          <div class="pull-right lr">
            了解你感兴趣的职业活动具备什么特点
          </div>
        </li>
         <li class="clearfix">
          <span class="pull-left"></span>
          <div class="pull-right lr">
            了解你擅长什么样的职业
          </div>
        </li>
         <li class="clearfix">
          <span class="pull-left"></span>
          <div class="pull-right lr">
            了解你期望的职业回报有哪些
          </div>
        </li>
      </ul>
      <h3>适合人群<span></span></h3>
      <ul>
        <li class="clearfix">
          <span class="pull-left"></span>
          <div class="pull-right lr">想要探索自己职业倾向的中学生、大学生、职场人士</div>
        </li>
      </ul>
      <h3>报告样例<span></span></h3>
      <ul>
        <li class="cp73-li clearfix">
          <img class="cp73-img" src="@a/ceping73/cp73-r1.jpg" alt="" >
          <img class="cp73-img" src="@a/ceping73/cp73-r2.jpg" alt="" >
          <img class="cp73-img" src="@a/ceping73/cp73-r3.jpg" alt="" >
          <img class="cp73-img" src="@a/ceping73/cp73-r4.jpg" alt="" >
        </li>
      </ul>
      <h3>测评须知<span></span></h3>
      <ul>
        <li class="clearfix">
          <span class="pull-left"></span>
          <div class="pull-right lr">答案没有好坏、对错之分，不必仔细推敲；请结合自己的实际情况，相信自己的第一感觉作答。</div>
        </li>
      </ul>
      <h2 class="clearfix h_v"><span class="pull-left"></span><span class="pull-right"></span></h2>
    </div> -->
    <div class="men_foots">
      <router-link :to="{path:'/ceping87_report',query:$route.query}" v-if="data.report">查看报告</router-link>
      <router-link :to="{path:'/ceping87',query:$route.query}" v-else>点击进入测评</router-link>
    </div>
  </div>
</template>
<script>
import {
  ceping87_detail,
  ceping_event,
} from "@/api/measurement";
import {
  queryString
} from "@/utils/tools";
import {
  shareCon
} from "@/utils/wxconfig";
let img = require('../../../assets/cep_ewm.png');
export default {
  data() {
      return {
        headImg: "",
        picture: "",
        data: {},
        body_show: false,
        subscribe: false,
        cids: "",
        card_show: false,
        imgLink: img,
        link: "",
        type_obj: {
          evaluation_id: "",
          evaluation_name: "",
          evaluation_id: ""
        }
      }
    },
    methods: {
      pullData() {
        let cid = this.$route.query.cid;
        ceping87_detail()
          .then((data) => {
            this.body_show = true;
            document.title = data.headtitle;
            this.data = data;
            shareCon("ceping73", this);

            ceping_event({ lead_sid: this.$route.query.lead_sid,
              cid: data.cid,
              event: 'ViewDetails',
            }).then(res=>{
              // 页面访问统计
            });

            // 神策统计--打开页面时触发
            // sensors.track('evaluationPage', {
            //   evaluation_id: this.$route.query.cid,
            //   evaluation_name: this.data.headtitle,
            //   evaluation_url: window.location.href,
            //   evaluation_page_title: this.data.headtitle,
            //   share_user_id: this.$route.query.share_uid ? this.$route.query.share_uid : "",
            //   channel_name: this.$route.query.channel ? this.$route.query.channel : ""
            // })
          })
      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.body_show {
  // padding-bottom: 198px;
  // background-color: #fde784;
}

.men_detail {
  width: 100%;
  text-align: center;
  position: relative;
  img {
    width: 100%;
  }
  img.logo{
    position: absolute;
    top: 20px;
    right: 10px;
    height: 70px;
    width: auto;
  }
}

.men_foots {
  width: 100%;
  height: 98px;
  line-height: 98px;
  position: fixed;
  bottom: 0;
  left: 50%;
  margin-left: -375px;
  max-width: 750px;
  text-align: center;
  background: #844955;
  z-index: 2;
  color: #fff;
  font-size: 34px;
  a {
    display: block;
    width: 100%;
    height: 100%;
    color: #fff
  }
}

.men_main {
  width: 690px;
  height: auto;
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;
  padding: 30px;
  margin: 0 auto;
  margin-top: -132px;
  position: relative;
  h2 {
    width: 100%;
    span {
      display: inline-block;
      width: 20px;
      height: 20px;
      background: rgba(132, 73, 85, 1);
      border-radius: 10px;
    }
  }
  .h_v {
    margin-top: 80px;
  }
  h3 {
    font-size: 34px;
    color: #333;
    position: relative;
    padding-bottom: 10px;
    margin-top: 50px;
    text-align: center;
    span {
      width: 68px;
      height: 4px;
      background: rgba(249, 207, 89, 1);
      display: inline-block;
      position: absolute;
      left: 50%;
      margin-left: -34px;
      bottom: 0
    }
  }
  p {
    margin-top: 50px;
    text-align: justify;
    line-height: 40px;
    color: #333;
    font-size: 26px;
  }
  p.ti{
    text-indent: 2em;
  }
  p.last_child {
    padding-bottom: 80px;
    border-bottom: 2px dashed #F9CF59;
  }
  ul {
    padding-bottom: 80px;
    border-bottom: 2px dashed #F9CF59;
    li {
      margin-top: 50px;
      span {
        display: inline-block;
        margin-right: 24px;
        background-color: #F9CF59;
        width: 12px;
        height: 12px;
        margin-top: 10px;
        border-radius: 50%;
      }
      .lr {
        width: 590px;
        color: #2C1B23;
        font-size: 26px;
        line-height: 40px;
      }
    }
  }
}
.cp73-li{
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-wrap: wrap;
  .cp73-img{
    width: 310px;
    height: 450px;
    &:nth-child(odd){
      margin-right: auto;
    }
  }
}

.imgs img {
  width: 100%;
  height: auto;
  vertical-align: bottom;
}
</style>
